import React from 'react';
import PropTypes from 'prop-types';

const ListHeader = props => (
  <div className="pf-c-dual-list-selector__header">
    <div className="pf-c-dual-list-selector__title">
      <div className="pf-c-dual-list-selector__title-text">{props.title}</div>
    </div>
  </div>
);

ListHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default ListHeader;



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_ansible-12.0.6/webpack/components/DualList/ListHeader.js